import { Component, HostListener } from '@angular/core';
import {
  Event,
  Router,
  NavigationStart,
  NavigationEnd,
} from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { PlatformLocation } from '@angular/common';
import {Trabajador} from "./shared/models/trabajador.model";
import {Usuario} from "./shared/models/usuario.model";
import {SecurityService} from "./shared/services/security.service";
import {TablaResponsiveService} from "./shared/services/tabla-responsive.service";
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  currentUrl: string;

  /**
   * En un campo numerico con foco, la rueda del mouse sube o baja el valor de a un «step»: al
   * bajar la pagina un sueldo de 1230 (step 0.01) quedaba en 1229.96. Se le quita el foco antes
   * de que el navegador cambie el valor, y la pagina se desplaza como siempre.
   */
  @HostListener('document:wheel', ['$event'])
  evitarCambioConRueda(event: WheelEvent): void {
    const activo = document.activeElement as HTMLInputElement;
    if (activo && activo.tagName === 'INPUT' && activo.type === 'number' && activo === event.target) {
      activo.blur();
    }
  }
  constructor(
      public _router: Router,
      location: PlatformLocation,
      private spinner: NgxSpinnerService,
      private trabajador: Trabajador,
      private usuario: Usuario,
      private security: SecurityService,
      private tablaResponsive: TablaResponsiveService,
  ) {
    // en el celular las tablas pasan a tarjetas (ver TablaResponsiveService)
    this.tablaResponsive.iniciar();
    this._router.events.subscribe((routerEvent: Event) => {
      if (routerEvent instanceof NavigationStart) {
        this.spinner.show();
        // location.onPopState(() => {
        //   window.location.reload();
        // });
        this.currentUrl = routerEvent.url.substring(
          routerEvent.url.lastIndexOf('/') + 1
        );
      }
      if (routerEvent instanceof NavigationEnd) {
        this.spinner.hide();
      }
      window.scrollTo(0, 0);
    });
    this.getPermisos();
  }


  getPermisos() {
    if(this.security.existeSesion()){
      this.trabajador.getPermisos().then((response: any) => {
        this.usuario.guardarPermisos(response.data);
      }).catch(error => {
      });
    }

  }
}
